import { ASSESSMENT_URL } from "../../Home/components/SpeakCta";

const BRAND_GREEN = "#33F7BE";

/* Booking CTA for the TNT Group partnership: the partner's red-coral brand gradient on a dark
   card, keeping the signature green action button. */
export function TntBookingCta() {
  return (
    <section id="book-strategy" aria-labelledby="tnt-cta-heading" className="scroll-mt-8 px-4 sm:px-6 py-16 md:py-24">
      <div className="max-w-7xl mx-auto">
        <div className="relative overflow-hidden rounded-[28px] md:rounded-[40px] bg-black text-white px-6 sm:px-10 py-16 md:py-24">
          {/* Red-coral partner-brand gradient wash. */}
          <div
            aria-hidden="true"
            className="pointer-events-none absolute inset-0"
            style={{
              background:
                "radial-gradient(120% 90% at 50% 0%, rgba(255,94,72,0.45) 0%, rgba(225,29,72,0.22) 38%, rgba(0,0,0,0) 72%)",
            }}
          />
          <div
            aria-hidden="true"
            className="pointer-events-none absolute -top-24 left-1/2 h-72 w-[46rem] -translate-x-1/2 rounded-full bg-[#ff5e48]/25 blur-[130px]"
          />

          <div className="relative max-w-3xl mx-auto flex flex-col items-center text-center">
            <p className="text-xs font-semibold uppercase tracking-widest text-[#ff9d8a] mb-5">TNT × Rentid</p>
            <h2
              id="tnt-cta-heading"
              className="font-heading text-3xl sm:text-4xl md:text-[52px] font-bold tracking-tighter leading-[1.03] text-balance"
            >
              Claim your benefits and start for free
            </h2>
            <p className="mt-5 max-w-xl text-base sm:text-lg leading-relaxed text-white/70 text-pretty">
              Everything to do anything rental, all in one place.
            </p>
            <a
              href={ASSESSMENT_URL}
              className="btn-pulse mt-10 inline-flex items-center justify-center text-center px-8 py-4 rounded-full text-base font-semibold text-black border-2 border-black transition-colors duration-200 hover:bg-[#2be0a8] active:scale-95"
              style={{ backgroundColor: BRAND_GREEN }}
            >
              Start for Free
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
